import {
  convertBidPreferenceEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime,
  convertBidEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime,
  getStationTimeZoneDateTimeStringFromUTCInteger,
} from "../timeZoneService";
import { BID_TYPE } from "./bidConstants";

export const getScrubbedBidAuditHistory = (bidAuditHistory, station) => {
  for (const bidAuditEvent of bidAuditHistory) {
    bidAuditEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(bidAuditEvent.createdAt, station);
  }

  return bidAuditHistory;
};

export const getScrubbedBidEvents = (bidEvents) => {
  let scrubbedBidEvents = [];

  for (const bidEvent of bidEvents) {
    scrubbedBidEvents.push(getScrubbedBidEvent(bidEvent));
  }

  return scrubbedBidEvents;
};

export const getScrubbedBidEvent = (bidEvent) => {
  let scrubbedBidEvent = JSON.parse(JSON.stringify(bidEvent));
  scrubbedBidEvent = convertBidEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(scrubbedBidEvent);
  scrubbedBidEvent.id = scrubbedBidEvent.referenceNumber;
  return scrubbedBidEvent;
};

export const getLatestSeniorityRankAfterExcludingIncomingTemps = (seniorityList) => {
  seniorityList.map((item, index) => (item.rank = index + 1));
  return seniorityList;
};

export const getScrubbedSeniorityList = (seniorityList, bidStation) => {
  let scrubbedList = [];
  seniorityList.forEach((employee) => {
    if (employee.homeStation === bidStation) {
      let scrubbedEmployee = JSON.parse(JSON.stringify(employee));
      scrubbedEmployee.rank = employee.rank.toString();
      scrubbedEmployee.isEligible = true;
      scrubbedEmployee.isEligibleAtOpen = true;
      scrubbedList.push(scrubbedEmployee);
    }
  });
  const reRankedList = getLatestSeniorityRankAfterExcludingIncomingTemps(scrubbedList);
  return reRankedList;
};

export const getScrubbedSeniorityListForFreeday = (seniorityList, standardReliefMap) => {
  let scrubbedList = [];
  seniorityList.forEach((employee) => {
    let scrubbedEmployee = JSON.parse(JSON.stringify(employee));
    scrubbedEmployee.rank = employee.rank.toString();
    scrubbedEmployee.isEligible = true;
    scrubbedEmployee.isEligibleAtOpen = true;
    if (standardReliefMap && Object.keys(standardReliefMap).includes(employee.eid)) {
      scrubbedEmployee.standardRelief = standardReliefMap[employee.eid];
    } else {
      scrubbedEmployee.standardRelief = "";
    }
    scrubbedList.push(scrubbedEmployee);
  });
  return scrubbedList;
};

export const getScrubbedSeniorityListForFTO = (seniorityList) => {
  let scrubbedList = [];
  seniorityList.forEach((employee) => {
    let scrubbedEmployee = JSON.parse(JSON.stringify(employee));
    scrubbedEmployee.rank = employee.rank.toString();
    scrubbedEmployee.isEligible = true;
    scrubbedEmployee.isEligibleAtOpen = true;
    scrubbedEmployee.balance = "-";
    scrubbedList.push(scrubbedEmployee);
  });
  return scrubbedList;
};

export const getScrubbedSeniorityListForDATFTO = (seniorityList) => {
  let scrubbedList = [];
  seniorityList.forEach((employee) => {
    let scrubbedEmployee = JSON.parse(JSON.stringify(employee));
    scrubbedEmployee.rank = employee.rank.toString();
    scrubbedEmployee.isEligible = true;
    scrubbedEmployee.isEligibleAtOpen = true;
    scrubbedEmployee.ftoBalance = "-";
    scrubbedEmployee.datBalance = "-";
    scrubbedList.push(scrubbedEmployee);
  });
  return scrubbedList;
};

export const getScrubbedSeniorityListForNC = (seniorityList, bidType) => {
  let scrubbedList = [];
  seniorityList.forEach((employee) => {
    let scrubbedEmployee = JSON.parse(JSON.stringify(employee));
    scrubbedEmployee.rank = employee.rank.toString();
    scrubbedEmployee.isEligible = true;
    scrubbedEmployee.isEligibleAtOpen = true;
    scrubbedEmployee.ptoBalance = "-";
    if (bidType === BID_TYPE.NC_PTO_FTO) {
      scrubbedEmployee.ftoBalance = "-";
    }
    if (bidType === BID_TYPE.NC_PTO_GOC_HOL) {
      scrubbedEmployee.gocHolBalance = "-";
    }
    scrubbedList.push(scrubbedEmployee);
  });
  return scrubbedList;
};

export const getScrubbedBidChoiceEvents = (bidChoiceEvents) => {
  let scrubbedBidChoiceEvents = [];

  for (const bidChoiceEvent of bidChoiceEvents) {
    scrubbedBidChoiceEvents.push(getScrubbedBidChoiceEvent(bidChoiceEvent));
  }

  return scrubbedBidChoiceEvents;
};

export const getScrubbedBidChoiceEvent = (bidChoiceEvent) => {
  let scrubbedBidChoiceEvent = JSON.parse(JSON.stringify(bidChoiceEvent));
  scrubbedBidChoiceEvent =
    convertBidPreferenceEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(scrubbedBidChoiceEvent);
  scrubbedBidChoiceEvent.id = scrubbedBidChoiceEvent.referenceNumber;
  return scrubbedBidChoiceEvent;
};

export const getScrubbedSeniorityListForIAMDAT = (seniorityList) => {
  let scrubbedList = [];
  seniorityList.forEach((employee) => {
    let scrubbedEmployee = JSON.parse(JSON.stringify(employee));
    scrubbedEmployee.rank = employee.rank.toString();
    scrubbedEmployee.isEligible = true;
    scrubbedEmployee.isEligibleAtOpen = true;
    scrubbedEmployee.datBalance = "-";
    scrubbedList.push(scrubbedEmployee);
  });
  return scrubbedList;
};
